module.exports = __webpack_public_path__ + "img/klaus-a3-2.650292e3.jpg";